import { MediaThumb, useMedia } from '@/features/media';

/** The list only carries media ids; the thumb resolves lazily from the media cache. */
export function StoreProductThumb({ mediaId }: { mediaId: string | null }) {
  const { data } = useMedia(mediaId);
  return <MediaThumb media={data} className="size-10 shrink-0 rounded-md border" />;
}
